import { render } from "./CustomerTop.vue?vue&type=template&id=4a5e42c9"
import script from "./CustomerTop.vue?vue&type=script&lang=js"
export * from "./CustomerTop.vue?vue&type=script&lang=js"

import "./CustomerTop.vue?vue&type=style&index=0&id=4a5e42c9&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__